<template>
	<section class="c-newsletter-signup">
		<!-- <form action="//bandara.us11.list-manage.com/subscribe/post?u=c8c447e436ec58665c71e4f4a&amp;id=5091853cf3" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
			<h2 class="c-newsletter-signup__headline">{{ newsletter_signup_label }}</h2>
			<input type="email" value="" name="EMAIL" placeholder="E-Mail" class="c-newsletter-signup__input" id="mce-EMAIL">
    	<div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_c8c447e436ec58665c71e4f4a_5091853cf3" tabindex="-1" value=""></div>
    	<button class="c-newsletter-signup__button" type="submit" name="subscribe" id="mc-embedded-subscribe">{{ newsletter_signup_button_text }}</button>
		</form> -->

		<!-- Begin MailChimp Signup Form -->
	   <transition appear name="u-anim-fade">
      <div v-if="!formSuccess && !loading">
        <label class="c-newsletter-signup__label">
          <h2 class="c-newsletter-signup__headline">{{ newsletter_signup_label }}</h2>
					<div class="c-newsletter-signup__inputcontainer">
						<input v-validate="'email'" placeholder="E-Mail" type="text" name="E-mail" v-model="emailString" v-bind:class="'c-newsletter-signup__input' + (errors.has('E-mail') ? ' c-newsletter-signup__input--error' : '')">
						<transition appear name="u-anim-fade">
							<h3 v-if="errors.has('E-mail')" class="c-newsletter-signup__error">{{ errors.first('E-mail') }}</h3>
						</transition>
					</div>
					<button :disabled="errors.has('E-mail') || emailString.length < 1" class='c-newsletter-signup__button' v-on:click="sendData()">{{ newsletter_signup_button_text }}</button>
        </label>
      </div>
    </transition>
		<transition appear name="u-anim-fade">
			<c-loader class="c-newsletter-signup__loader" v-if="loading"/>
		</transition>
    <div v-if="formMessage && !loading" v-bind:class="'c-newsletter-signup__message-container' + (formSuccess ? ' c-newsletter-signup__message-container--success' : '') + (!formSuccess && formMessage ? ' c-newsletter-signup__message-container--error' : '')">
      <!-- <div v-if="loading" class="Newsletter__loader">{{ $t('newsletter.senden') }}</div> -->
			<transition appear name="u-anim-fade">
        <h3 v-if="formSuccess" class="c-newsletter-signup__message">{{ formMessage }}</h3>
        <h3 v-else class="c-newsletter-signup__message c-newsletter-signup__message--error" v-html="formMessage"></h3>
			</transition>
    </div>
		<!--End mc_embed_signup-->
	</section>
</template>

<script>
import CLoader from '@/components/Loader'
import Vue from 'vue'
import VueJsonp from 'vue-jsonp'
import VeeValidate, { Validator } from 'vee-validate';
import de from 'vee-validate/dist/locale/de'

Vue.use(VeeValidate, { locale: 'de' })
Validator.localize('de', de);

Vue.use(VueJsonp)

export default {
	name: 'newsletter-signup',
	components: {
		CLoader
	},
	data () {
    return {
      Email: '',
      emailString: '',
      formSuccess: false,
      formMessage: '',
      loading: false
    }
  },
	computed: {
		settings() {
			return this.$store.state.general.settings;
		},
		newsletter_signup_button_text() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].newsletter_signup_button_text
		},
		newsletter_signup_label() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].newsletter_signup_label
		}
	},
	methods: {
    hideMessage () {
      this.formMessage = ''
      this.formSuccess = false
    },
    sendData () {
      this.loading = true
      if (!this.errors.has('email') && this.emailString.length) {
        this.$jsonp('https://blog.us11.list-manage.com/subscribe/post-json?u=c8c447e436ec58665c71e4f4a&amp;id=5091853cf3', {
          'EMAIL': this.emailString,
          callbackQuery: 'c',
          callbackName: 'jsonpFunc'
        }).then(json => {
          this.loading = false
          if (json.result === 'success') {
            this.formSuccess = true
            this.formMessage = json.msg
          } else {
            this.formSuccess = false
            this.formMessage = json.msg
          }
        })
      } else {
        this.loading = false
      }
    }
  }
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	$m: 'c-newsletter-signup';

	.u-anim-fade-enter-active {
	  transition-duration: 0.25s;
	  transition-property: opacity;
	}

	.u-anim-fade-enter {
	  opacity: 0;
	}

	.#{$m} {
		width: 100%;
		height: auto;
		background-color: $colorBrandSecondary;
		text-align: center;
		padding: 2.5rem 1rem;
		color: #fff;
		position: relative;
		z-index: 1;

		form {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
		}

		&__label {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			align-items: center;
		}

		&__headline {
			display: inline-block;
			font-size: 1rem;
			text-align: left;
			width: 100%;
			text-align: center;
			margin-bottom: 1rem;

			@include mq($from: medium) {
				width: auto;
				text-align: left;
				margin-right: 1rem;
				margin-bottom: 0;
			}
		}
		&__inputcontainer {
			display: inline-block;
			position: relative;
			width: 70%;

			@include mq($from: medium) {
				width: auto;
			}
		}
		&__error,
		&__message {
			position: absolute;
			text-align: left;
			bottom: 0;
			left: 0;
			transform: translateY(108%);
			font-size: 0.75rem;
			font-weight: 500;
			color: $colorGray;
		}
		&__message {
			position: relative;
			bottom: inherit;
			left: inherit;
			transform: none;
			text-align: center;
			color: $colorWhite;

			a:hover {
				color: $colorGray;
			}

			&--error {
				margin-top: 10px; // optical
			}
		}
		&__input {
			width: 100%;
			position: relative;
			background-color: transparent;
			border: 2px solid #384853;
			font-size: 1rem;
			font-family: $fontFamilyBase;
			padding: 0 .5rem;
			height: 2rem;
			line-height: 2rem;
			color: #fff;
			max-width: 15rem;
			border-radius: 0;

			@include mq($from: medium) {
				width: 13rem;
			}

			&:focus {
				outline: none;
				border-color: rgba(#fff, .8);
			}
			&::placeholder {
				color: #87949E;
			}
		}
		&__button {
			font-size: 1rem;
			font-family: $fontFamilyBase;
			color: rgba(#fff, .8);
			background-color: #384853;
			border: none;
			height: 2rem;
			cursor: pointer;
			width: 30%;
			max-width: 8rem;

			&:disabled {
				cursor: not-allowed;

				&:hover {
					color: rgba(#fff, .8);
				}
			}

			@include mq($from: medium) {
				width: 13rem;
			}

			&:hover {
				color: #fff;
			}
			&:focus, &:active {
				outline: none;
				color: #fff;
			}
		}
	}


</style>



// WEBPACK FOOTER //
// NewsletterSignup.vue?8e6277f2